import { onBeforeUnmount, onMounted, readonly, ref } from 'vue'
import {
  isDesktopWorkspace,
  isLandscapeLayoutViewport,
  isMobileWorkspace,
  readLayoutOrientation,
  resolvePortraitLayoutViewport,
  type LayoutOrientation,
} from '@/platform/viewport/layoutViewport'

/**
 * 响应式布局视口状态：PC/移动端工作区、横竖屏 UI 分支与物理朝向。
 * 监听 resize / visualViewport 变化，供各模块统一引用，避免散落 matchMedia 判断。
 */
export function useLayoutViewport() {
  const isMobile = ref(false)
  const isDesktop = ref(false)
  const isPortraitLayout = ref(false)
  const isLandscapeLayout = ref(false)
  const orientation = ref<LayoutOrientation>('landscape')

  function syncLayoutViewport(): void {
    if (typeof window === 'undefined') return
    isMobile.value = isMobileWorkspace()
    isDesktop.value = isDesktopWorkspace()
    isPortraitLayout.value = resolvePortraitLayoutViewport(
      undefined,
      isPortraitLayout.value,
    )
    isLandscapeLayout.value = isLandscapeLayoutViewport()
    orientation.value = readLayoutOrientation()
  }

  onMounted(() => {
    syncLayoutViewport()
    window.addEventListener('resize', syncLayoutViewport)
    window.visualViewport?.addEventListener('resize', syncLayoutViewport)
    window.visualViewport?.addEventListener('scroll', syncLayoutViewport)
    window.screen?.orientation?.addEventListener?.('change', syncLayoutViewport)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', syncLayoutViewport)
    window.visualViewport?.removeEventListener('resize', syncLayoutViewport)
    window.visualViewport?.removeEventListener('scroll', syncLayoutViewport)
    window.screen?.orientation?.removeEventListener?.('change', syncLayoutViewport)
  })

  return {
    isMobileWorkspace: readonly(isMobile),
    isDesktopWorkspace: readonly(isDesktop),
    isPortraitLayout: readonly(isPortraitLayout),
    isLandscapeLayout: readonly(isLandscapeLayout),
    orientation: readonly(orientation),
    syncLayoutViewport,
  }
}
